    <template>
            <div>
                <div class="flex w-full items-center justify-center h-screen">
                    <div class="sm:block w-1/2 bg-cover h-screen" style='background: url(password-rec-2.jpg)'>
                        <div class="bg-blue-800 w-full h-screen bg-opacity-20">
                        </div>
                    </div>
                    <div class="sm:w-1/2">
                        <div class="p-5 w-4/5 mx-auto text-left font-raleway">
                            <div class="text-left mb-10"> 
                                <router-link to="/login">
                                    <font-awesome-icon class="mr-5" :icon="['fas', 'arrow-left']" /> Login
                                </router-link> 
                            </div>
                            
                            <h1 class="font-bold text-left font-montserrat text-4xl sm:text-6xl mb-10">
                                Reset Your. eduBB. Password
                            </h1>
                            <p v-show="done" class="text-sm text-green-500">Password reset success</p>
                            <p v-show="error" class="text-sm text-red-500">An error occurred</p>
                            <p v-show="showPasswordMatch" class="text-sm text-green-500">Passwords match</p>
                            <form @submit="resetPassword">
                                <div class="my-5">
                                    <h1 class="text-left font-bold mb-5 font-montserrat">Passwort</h1>
                                    <input 
                                    id="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    value
                                    name="password"
                                    autofocus
                                    v-model="form.password"
                                    class="text-sm outline-none pb-5 w-4/5 bg-transparent border-b hover:border-blue-700 focus:border-blue-700" 
                                    @input="clearError"
                                    :minlength="6"
                                    />
                                    
                                  </div>
                                <div class="my-5">
                                    <h1 class="text-left font-bold mb-5 font-montserrat">Passwort bestätigen</h1>
                                    <input
                                      id="passwordConfirmed"
                                      type="password"
                                      class="text-sm outline-none pb-5 w-5/5 bg-transparent border-b hover:border-blue-700 focus:border-blue-700"
                                      name="password"
                                      value
                                      required
                                      v-model="form.passwordConfirmation"
                                      @input="clearError"                    
                                    />
                                  </div>    
                                  <label for="showPassword" class="ml-2">
                                    <input
                                      id="showPassword"
                                      type="checkbox"
                                      v-model="showPassword"
                                    />
                                    Passwort anzeigen
                                  </label>
                                  <b-message type="is-warning">
                                    Das neue Passwort muss mindestens 6 Zeichen lang sein. Stimmen die Passwörter überein, wird eine Erfolgsnachricht angezeigt.
                                  </b-message>
                                <button 
                                  type="submit" 
                                  class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full"
                                  >
                                    Reset Passwort <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </template>

<script>
import axios from 'axios'

import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { NotificationProgrammatic as Notification } from 'buefy';

library.add(faEye, faEyeSlash);

export default {
    name: 'ResetPassword',
    data() {
    return {
        form: {
          password: "",
          passwordConfirmation: "",
        },
        API_URL:
        process.env.NODE_ENV == "production"
            ? process.env.VUE_APP_STRAPI_API_URL
            : "http://localhost:1338",
        error: false,
        done: false,
        showPassword: false,
    };
  },
  computed: {
    passwordsMatch() {
      return this.form.password === this.form.passwordConfirmation && this.form.password.length >= 6;
    },
    showPasswordMatch() {
      return this.passwordsMatch && !this.error;
    },
    errorMessage() {
      if (this.form.password.length > 0 && this.form.password.length < 6) {
        return     Notification.open({
            message: 'Your password is too short',
            type: 'is-warning',
            duration: 5000,
            position: 'is-bottom-right',
          });
      }
      return 'An error occurred';
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    clearError() {
      this.error = false;
    },
    async resetPassword(e) {
      e.preventDefault()
      
      const password = this.form.password;
      const passwordConfirmation = this.form.passwordConfirmation;
      const code = this.$router.currentRoute.query.code

      const data = {
        code,
        password,
        passwordConfirmation
    }

       await axios({
        method: 'POST',
        url: `${this.API_URL}`+ `/auth/reset-password`,
        data
      }).then(() => {
        // Handle Success
        this.done = true
        this.error = false

         // Redirect to login page after a delay
        setTimeout(() => {
          this.$router.push('/login');
          this.$buefy.toast.open('Erfolgreich geändert - Bitte einloggen');
        }, 1000);
        //console.log("ResetPassword.submit userPasswordRes", userPasswordRes)
      }).catch(error => {
        // Handle error
        this.error = true
        setTimeout(() => {
        this.$buefy.toast.open('Fehler beim ändern des Passworts');
      }, 1500);
        console.log('An error', error.response)
      })


      // THis ist with Firebase Auth
/*       createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then((data) => {
          data.user
            .updateProfile({
              displayName: this.form.name,
            })
            .then(() => {});
        })
        .catch((err) => {
          this.error = err.message;
        }); */


    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}

.toggle-password-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
